import { DataLoader } from 'src/app/services/data-loader/data-loader';

export const createCase1 = () => {
    return new DataLoader('', async function (queryContext, cancellationToken) {
        // wait
        await new Promise((resolve) => setTimeout(resolve, 1000));
        this.emitter.emit({
            data: [
                {
                    date: '2024-09-01',
                    mau: 612511,
                    new_users: 153162,
                    dates: 12,
                    avg_monthly_dau: 288553.25,
                },
                {
                    date: '2024-10-01',
                    mau: 960872,
                    new_users: 426669,
                    dates: 31,
                    avg_monthly_dau: 289092.06451612903,
                },
                {
                    date: '2024-11-01',
                    mau: 953161,
                    new_users: 425702,
                    dates: 30,
                    avg_monthly_dau: 289873.9,
                },
                {
                    date: '2024-12-01',
                    mau: 944571,
                    new_users: 416477,
                    dates: 31,
                    avg_monthly_dau: 274817.32258064515,
                },
                {
                    date: '2025-01-01',
                    mau: 1069761,
                    new_users: 529226,
                    dates: 31,
                    avg_monthly_dau: 293529.7419354839,
                },
                {
                    date: '2025-02-01',
                    mau: 1096193,
                    new_users: 541067,
                    dates: 28,
                    avg_monthly_dau: 308863.28571428574,
                },
                {
                    date: '2025-03-01',
                    mau: 1142983,
                    new_users: 549518,
                    dates: 31,
                    avg_monthly_dau: 312538.22580645164,
                },
                {
                    date: '2025-04-01',
                    mau: 1088392,
                    new_users: 490817,
                    dates: 30,
                    avg_monthly_dau: 304632.26666666666,
                },
                {
                    date: '2025-05-01',
                    mau: 1047753,
                    new_users: 445808,
                    dates: 31,
                    avg_monthly_dau: 295546.06451612903,
                },
                {
                    date: '2025-06-01',
                    mau: 883135,
                    new_users: 331569,
                    dates: 30,
                    avg_monthly_dau: 268482.93333333335,
                },
                {
                    date: '2025-07-01',
                    mau: 831381,
                    new_users: 314516,
                    dates: 31,
                    avg_monthly_dau: 240767.4516129032,
                },
                {
                    date: '2025-08-01',
                    mau: 985529,
                    new_users: 478313,
                    dates: 31,
                    avg_monthly_dau: 251006.93548387097,
                },
                {
                    date: '2025-09-01',
                    mau: 782363,
                    new_users: 309539,
                    dates: 18,
                    avg_monthly_dau: 263021.27777777775,
                },
            ],
            queryContext: { datasourceColumns: [], settings: {} },
            status: 'ok',
            statusMessage: '',
            isLoading: false,
            sqlAndJsProcessing: '',
        });
    });
};
